module.exports = __webpack_public_path__ + "img/configuracion-management.b828d547.png";